import { PermissionsUtil } from "./PermissionsUtil";
import { StringUtil } from "./StringUtil";
import { UrlUtil } from "./UrlUtil";
import { ValueOrFunction } from "./ValueOrFunctionTypes";
import { ValueResolver } from "./ValueResolver";

export class LayoutNameResolver {
    public static resolve(layoutPath: ValueOrFunction<string>, inDesigner: boolean = false): string | null {
        let resolvedPath = ValueResolver.resolve(layoutPath);

        if (StringUtil.isEmptyString(resolvedPath)) {
            return null;
        }

        if (inDesigner) {
            return resolvedPath;
        }
        resolvedPath = UrlUtil.trimQueryString(resolvedPath);
        return PermissionsUtil.isUserDeniedLayout(resolvedPath) ? null : resolvedPath;
    }
}
